import { render } from "./NfseServiceEdit.vue?vue&type=template&id=1677d24c"
import script from "./NfseServiceEdit.vue?vue&type=script&lang=js"
export * from "./NfseServiceEdit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__